import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { truckIcon, createMarkerIcon } from "./mapUtils";
import iconViolet from "./img/marker-icon-2x-violet.png";
import iconGold from "./img/marker-icon-2x-gold.png";

export default function MapCouriers({
  courierLocations = [],
  allowedUsersLocations = {},
  userLocation,
}) {
  return (
    <>
      {courierLocations.map((c, i) => (
        <Marker
          key={`courier-${i}`}
          position={[c.latitude, c.longitude]}
          icon={truckIcon}
        >
          <Popup>
            Курьер {c.name || "без имени"}
            <br />
            ({c.latitude.toFixed(4)}, {c.longitude.toFixed(4)})
          </Popup>
        </Marker>
      ))}

      {Array.isArray(userLocation) && (
        <Marker
          position={userLocation}
          icon={createMarkerIcon(iconViolet)}
        >
          <Popup>Вы здесь</Popup>
        </Marker>
      )}

      {allowedUsersLocations &&
        Object.entries(allowedUsersLocations).map(([id, loc]) => {
          const lat = Number(loc?.lat);
          const lng = Number(loc?.lng);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
          return (
            <Marker
              key={`allowed-${id}`}
              position={[lat, lng]}
              icon={createMarkerIcon(iconGold)}
            >
              <Popup>Пользователь {id}</Popup>
            </Marker>
          );
        })}
    </>
  );
}
